const ADD_NUMBER = 'ADD_NUMBER';
const MINUS_NUMBER = 'MINUS_NUMBER';

const state = {
  number: 1
};

const mutations = {
  [ADD_NUMBER] (state, { number }) {
    state.number = number;
  },
  [MINUS_NUMBER] (state, { number }) {
    state.number = number;
  }
};

const actions = {
  add ({ state, commit }) {
    commit(ADD_NUMBER, { number: state.number + 1 });
  },
  remove ({ state, commit }) {
    commit(MINUS_NUMBER, { number: state.number - 1 });
  }
};

export default {
  state,
  mutations,
  actions
};
